import { render, staticRenderFns } from "./ClinicianDetails.vue?vue&type=template&id=117f2fe4&scoped=true&"
import script from "./ClinicianDetails.vue?vue&type=script&lang=js&"
export * from "./ClinicianDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClinicianDetails.vue?vue&type=style&index=0&id=117f2fe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f2fe4",
  null
  
)

export default component.exports